export default "__VITE_ASSET__4bfb7c58__"